import * as React from "react";
import { User, Category } from "../api/classes";
import {
  Avatar,
  Typography,
  MenuItem,
  createStyles,
  withStyles
} from "@material-ui/core";
import { connect } from "react-redux";
import { GlobalState } from "../store";
import { RouteComponentProps } from "react-router-dom";
import * as actions from "../store/cases/actions";
import CategoryIcon from "@material-ui/icons/Category";
import { components } from "./filter";
import Select from "react-select";
import { emphasize } from "@material-ui/core/styles/colorManipulator";

interface Props {
  classes: any;
  id: number;
  noCaption?: boolean;
  categories: Category[];
  style?: React.CSSProperties;
  zIndex?: number;
  readOnly?: boolean;
  onSelect: (id: number) => void;
  fetchCategories: () => void;
}
interface State {}
class UserSelect extends React.Component<Props, State> {
  componentWillMount() {
    if (!this.props.categories) {
      this.props.fetchCategories();
    }
  }
  handleChange = e => {
    this.props.onSelect(e.value);
    //console.log(e);
  };

  render() {
    const { categories } = this.props;
    if (categories) {
      const cats = categories.map(c => ({
        label: c.title,
        value: c.id
      }));
      if (this.props.readOnly) {
        return this.renderReadOnly();
      }
      return (
        <div
          style={{
            ...this.props.style,
            position: "relative",
            height: this.props.noCaption ? 32 : 64,
            minWidth: 200
          }}
        >
          <CategoryIcon
            style={{
              position: "absolute",
              left: 0,
              width: 20,
              height: 20,
              bottom: this.props.noCaption && 20,
              top: this.props.noCaption ? 8 : 24,
              marginRight: 24
            }}
          />
          {/*  <Select
            disableUnderline
            style={{
              alignSelf: "flex-start",
              paddingLeft: 32
            }}
            value={this.props.id}
            onChange={this.handleChange}
            inputProps={{
              name: "age",
              id: "age-simple"
            }}
          >
            <MenuItem value="-" disabled>
              Select Category
            </MenuItem>
            {this.props.categories.map(u => {
              return <MenuItem value={u.id}>{u.title}</MenuItem>;
            })}
          </Select> */}
          <div
            style={{
              marginLeft: 32,
              position: "absolute",
              zIndex: this.props.zIndex ? this.props.zIndex : 1000,
              left: 0,
              right: 0
            }}
          >
            <Select
              classes={this.props.classes}
              textFieldProps={
                !this.props.noCaption && {
                  label: "Category",

                  InputLabelProps: {
                    shrink: true,
                    style: { fontSize: 16, marginLeft: -32 }
                  }
                }
              }
              options={cats}
              components={components}
              value={cats.find(i => i.value === this.props.id)}
              onChange={this.handleChange}
              placeholder={"Select Category"}
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
  renderReadOnly() {
    const category = this.props.categories.find(i => i.id === this.props.id);
    return (
      <div
        style={{
          ...this.props.style,
          position: "relative",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 28
        }}
      >
        <CategoryIcon
          style={{
            width: 20,
            height: 20,
            marginRight: 12
          }}
        />
        <Typography variant="body2">{category && category.title}</Typography>
      </div>
    );
  }
}
const styles = theme =>
  createStyles({
    root: {
      flexGrow: 1,
      "& div": {
        zIndex: 1,
        position: "absolute"
      }
    },
    input: {
      display: "flex",
      padding: 0
    },
    valueContainer: {
      display: "flex",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center"
    },
    chip: {
      margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
    },
    chipFocused: {
      backgroundColor: emphasize(
        theme.palette.type === "light"
          ? theme.palette.grey[300]
          : theme.palette.grey[700],
        0.08
      )
    },
    noOptionsMessage: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
    },
    singleValue: {
      fontSize: 16
    },
    placeholder: {
      position: "absolute",
      left: 2,
      fontSize: 16
    },
    paper: {
      marginTop: theme.spacing.unit
    },
    divider: {
      height: theme.spacing.unit * 2
    }
  });
export default connect(
  (state: GlobalState, own: Props) => ({
    categories: state.cases.categories
  }),
  dispatch => ({
    fetchCategories: (): any => dispatch(actions.fetchCategories())
  })
)(withStyles(styles, { withTheme: true })(UserSelect));



// WEBPACK FOOTER //
// ./src/components/categorySelect.tsx